import { Box, FormLabel, Switch } from '@chakra-ui/react'
import { useContext } from 'react'

import { SwitchControl } from '../../components/SwitchControl'
import { flexGroupListContext } from '../../pages/flex-group/list'
import { SearchField } from '../shared/SearchField'

export const FlexGroupListFilter = () => {
  const { filter, updateFilter, setCurrentPage } =
    useContext(flexGroupListContext)

  return (
    <Box sx={{ display: 'flex', gap: 4 }}>
      <SearchField
        onSearch={(search) => updateFilter({ ...filter, name: search })}
      />

      <SwitchControl sx={{ flexGrow: 1, justifyContent: 'right' }} mr={2}>
        <Switch
          size="md"
          id="showInactive"
          isChecked={filter.showInvalid}
          onChange={() => {
            updateFilter({ ...filter, showInvalid: !filter.showInvalid })
            setCurrentPage(1)
          }}
        />
        <FormLabel htmlFor="showInactive" variant="switch">
          Zobrazit i neaktivní
        </FormLabel>
      </SwitchControl>
    </Box>
  )
}
